export const selectIndicators = state => state.partners.indicators;

export const selectPartner = state => state.partners.partner;

export const selectHistory = state => state.partners.history;

export const selectIsLoading = state => state.partners.isLoading;

export const selectError = state => state.partners.error;